import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-weight-cell',
  templateUrl: './weight-cell.component.html',
})
export class WeightCellComponent {
  @Input() data: number;
}
